import { showToast, showAlert } from "../../utils/helpers/ShowToast";
import { fetchProducts } from "../../actions/productAction";
import { fetchProductGroups } from "../../actions/productGroupAction";
import authorizedAxios from "../../helpers/authorizedAxios";
export const SET_SALES = "SET_SALES";
export const SET_SALE = "SET_SALE";
export const SET_SALES_LOADING = "SET_SALES_LOADING";
export const SET_SALES_ERROR = "SET_SALES_ERROR";

const generatedSaleKeys = new WeakMap();
const saleIdempotencyKey = (data) => {
  if (data?.idempotency_key) return data.idempotency_key;
  if (generatedSaleKeys.has(data)) return generatedSaleKeys.get(data);

  const key =
    typeof window !== "undefined" && typeof window.crypto?.randomUUID === "function"
      ? `sale-${window.crypto.randomUUID()}`
      : `sale-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  generatedSaleKeys.set(data, key);
  return key;
};

export const fetchSales = (limit = 100, page = 1, search = "", status = "", filters = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_SALES_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/sales", {
        params: {
          limit,
          page,
          search,
          status: status || undefined,
          start_date: filters?.start_date || undefined,
          end_date: filters?.end_date || undefined,
        },
      });

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_SALES,
          data: response?.data?.data,
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_SALES_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data.",
      });
    } finally {
      dispatch({ type: SET_SALES_LOADING, status: false });
    }
  };
};

export const getSaleById = (id, options = {}) => {
  return async (dispatch) => {
    if (options?.silent !== true) {
      dispatch({ type: SET_SALES_LOADING, status: true });
    }

    try {
      const response = await authorizedAxios.get("/sales/" + id);

      if (response.status === 200 || response.status === 201) {
        const detail = response?.data?.data;
        dispatch({
          type: SET_SALE,
          data: detail,
        });
        return { success: true, data: detail };
      }

      return { success: false };
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_SALES_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data.",
      });
      return { success: false, error };
    } finally {
      if (options?.silent !== true) {
        dispatch({ type: SET_SALES_LOADING, status: false });
      }
    }
  };
};
export const addSale = (data, options = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_SALES_LOADING, status: true });
    const payload = { ...data, idempotency_key: saleIdempotencyKey(data) };
    const shouldPrint = options?.print !== false && payload?.payment_status !== "draft";

    try {
      const response = await showToast(authorizedAxios.post("/sales", payload), {
        loading: "Menyimpan data...",
        // success: payload?.payment_status === "draft" ? "Draft sale berhasil disimpan!" : "Data sale berhasil ditambahkan!",
        error: (err) => err?.response?.data?.message || "Gagal menyimpan data!",
      });
      if (response.status === 200 || response.status === 201) {
        if (shouldPrint) {
          showAlert({
            type: "success",
            message: "Data sale berhasil ditambahkan!",
            isPrint: true,
            printUrl: `sales/print-invoice/${response?.data?.data}`,
          });
        }
        await Promise.all([dispatch(fetchSales()), dispatch(fetchProducts()), dispatch(fetchProductGroups())]);
        return { success: true, id: response?.data?.data };
      }

      return { success: false };
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_SALES_ERROR,
        error: error?.message || "Terjadi kesalahan.",
      });
      return { success: false, error };
    } finally {
      dispatch({ type: SET_SALES_LOADING, status: false });
    }
  };
};
export const processSale = (id, data = {}, options = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_SALES_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.put(`/sales/process/${id}`, data), {
        loading: "Memproses transaksi...",
        success: "Transaksi berhasil diproses!",
        error: (err) => err?.response?.data?.message || "Gagal memproses transaksi!",
      });
      if (response.status === 200 || response.status === 201) {
        if (options?.refreshSales !== false) {
          await dispatch(fetchSales());
        }

        await dispatch(fetchProducts());
        await dispatch(fetchProductGroups());
        return true;
      }

      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_SALES_ERROR,
        error: error?.message || "Terjadi kesalahan.",
      });
      return false;
    } finally {
      dispatch({ type: SET_SALES_LOADING, status: false });
    }
  };
};
export const cancelSale = (id, reason, options = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_SALES_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.put(`/sales/cancel/${id}`, { reason }), {
        loading: "Membatalkan transaksi...",
        success: "Transaksi berhasil dibatalkan!",
        error: (err) => err?.response?.data?.message || "Gagal membatalkan transaksi!",
      });
      if (response.status === 200 || response.status === 201) {
        if (options?.refreshSales !== false) {
          await dispatch(fetchSales());
        }

        await dispatch(fetchProducts());
        await dispatch(fetchProductGroups());
        return true;
      }

      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_SALES_ERROR,
        error: error?.message || "Terjadi kesalahan.",
      });
      return false;
    } finally {
      dispatch({ type: SET_SALES_LOADING, status: false });
    }
  };
};
export const settleSale = (id, data, options = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_SALES_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.put(`/sales/payment/${id}`, data), {
        loading: "Memproses pelunasan...",
        success: "Pelunasan sale berhasil disimpan!",
        error: (err) => err?.response?.data?.message || "Gagal memproses pelunasan!",
      });
      if (response.status === 200 || response.status === 201) {
        if (options?.refreshSales !== false) {
          await dispatch(fetchSales());
        }

        return true;
      }

      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_SALES_ERROR,
        error: error?.message || "Terjadi kesalahan.",
      });
      return false;
    } finally {
      dispatch({ type: SET_SALES_LOADING, status: false });
    }
  };
};

export const fetchSaleBills = (saleId) => {
  return async () => {
    try {
      const response = await authorizedAxios.get("/sale-bills", { params: { sale_id: saleId } });
      return { success: true, data: response?.data?.data || [] };
    } catch (error) {
      return { success: false, error, data: [] };
    }
  };
};

export const fetchEligibleSaleBills = () => {
  return async () => {
    try {
      const response = await authorizedAxios.get("/sale-bills", { params: { eligible: 1 } });
      return { success: true, data: response?.data?.data || [] };
    } catch (error) {
      return { success: false, error, data: [] };
    }
  };
};

export const splitSaleBill = (billId, groups, options = {}) => {
  return async (dispatch) => {
    try {
      const response = await showToast(authorizedAxios.post(`/sale-bills/${billId}/split`, { groups }), {
        loading: "Membagi tagihan...",
        success: "Tagihan berhasil dibagi",
        error: (error) => error?.response?.data?.message || "Tagihan gagal dibagi",
      });
      if (options?.refreshSales !== false) await dispatch(fetchSales());
      await Promise.all([dispatch(fetchProducts()), dispatch(fetchProductGroups())]);
      return { success: true, data: response?.data?.data || [] };
    } catch (error) {
      return { success: false, error };
    }
  };
};

export const mergeSaleBills = (billIds, label, options = {}) => {
  return async (dispatch) => {
    try {
      const response = await showToast(authorizedAxios.post("/sale-bills/merge", { bill_ids: billIds, label }), {
        loading: "Menggabungkan tagihan...",
        success: "Tagihan berhasil digabungkan",
        error: (error) => error?.response?.data?.message || "Tagihan gagal digabungkan",
      });
      if (options?.refreshSales !== false) await dispatch(fetchSales());
      return { success: true, data: response?.data?.data };
    } catch (error) {
      return { success: false, error };
    }
  };
};

export const paySaleBill = (billId, payload, options = {}) => {
  return async (dispatch) => {
    try {
      const response = await showToast(authorizedAxios.post(`/sale-bills/${billId}/payment`, payload), {
        loading: "Memproses pembayaran tagihan...",
        success: "Pembayaran tagihan berhasil disimpan",
        error: (error) => error?.response?.data?.message || "Pembayaran tagihan gagal diproses",
      });
      if (options?.refreshSales !== false) await dispatch(fetchSales());
      await Promise.all([dispatch(fetchProducts()), dispatch(fetchProductGroups())]);
      return { success: true, data: response?.data?.data };
    } catch (error) {
      return { success: false, error };
    }
  };
};

export const undoSaleBill = (billId, reason = "", options = {}) => {
  return async (dispatch) => {
    try {
      const response = await showToast(authorizedAxios.post(`/sale-bills/${billId}/undo`, { reason }), {
        loading: "Mengoreksi penggabungan tagihan...",
        success: "Penggabungan tagihan berhasil dikoreksi",
        error: (error) => error?.response?.data?.message || "Penggabungan tagihan gagal dikoreksi",
      });
      if (options?.refreshSales !== false) await dispatch(fetchSales());
      return { success: true, data: response?.data?.data || [] };
    } catch (error) {
      return { success: false, error };
    }
  };
};
export const updateSale = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_SALES_LOADING, status: true });
    try {
      const response = await showToast(authorizedAxios.put(`/sales/${id}`, data), {
        loading: data.payment_amount ? "Menyimpan perubahan dan pembayaran..." : "Menyimpan perubahan...",
        success: data.payment_amount ? "Perubahan dan pembayaran berhasil disimpan." : "Transaksi berhasil diperbarui.",
        error: (err) => err?.response?.data?.message || "Gagal mengupdate data!",
      });
      if (response.status === 200 || response.status === 201) {
        await Promise.all([dispatch(fetchSales()), dispatch(fetchProducts()), dispatch(fetchProductGroups())]);
        return { success: true, id: response?.data?.data };
      }
      return { success: false };
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_SALES_ERROR,
        error: error?.message || "Terjadi kesalahan.",
      });
      return { success: false, error };
    } finally {
      dispatch({ type: SET_SALES_LOADING, status: false });
    }
  };
};
export const deleteSale = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_SALES_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.delete(`/sales/${id}`), {
        loading: "Menghapus data...",
        success: "Data sale berhasil dihapus!",
        error: (err) => err?.response?.data?.message || "Gagal menghapus data!",
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data sale berhasil dihapus!",
        });
        dispatch(fetchSales());
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_SALES_ERROR,
        error: error?.message || "Terjadi kesalahan.",
      });
    } finally {
      dispatch({ type: SET_SALES_LOADING, status: false });
    }
  };
};
